import { render, staticRenderFns } from "./AllRoleContainer.vue?vue&type=template&id=1268ab73"
import script from "./AllRoleContainer.vue?vue&type=script&lang=ts"
export * from "./AllRoleContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports